// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app .e-input-group{--tw-border-opacity:1;border-color:rgb(220 38 38/var(--tw-border-opacity));border-width:1px;font-size:.875rem;line-height:1.25rem}", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,oBAAA,qBAAA,CAAA,oDAAA,CAAA,gBAAA,CAAA,iBAAA,CAAA,mBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
